import { style } from 'typestyle'
export const mb20 = style({ marginBottom: '20px' })
